import { Box, IconButton, SvgIcon } from '@mui/material';
import SearchIcon from 'assets/icons/search.svg';
import Loading from 'components/common/Loading';
import SearchField from 'components/controls/SearchField';
import { bool, func } from 'prop-types';
import React, { memo, useEffect, useRef } from 'react';
import useOpenClose from 'utils/useOpenClose';

const Search = ({ onChange, isFetching = false }) => {
  const inputRef = useRef();
  const [isVisible, makeVisible] = useOpenClose(false);

  useEffect(() => {
    if (isVisible) {
      inputRef.current?.focus();
    }
  }, [isVisible]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {isVisible && (
        <SearchField
          inputRef={inputRef}
          onChange={onChange}
          InputProps={
            isFetching
              ? {
                  startAdornment: (
                    <Loading color="secondary" sx={{ width: 'auto', ml: 1 }} size={20} />
                  ),
                }
              : {}
          }
        />
      )}
      {!isVisible && (
        <IconButton sx={{ ml: '5px' }} onClick={makeVisible} size="large">
          <SvgIcon color="primary" sx={{ fontSize: '16px' }}>
            <SearchIcon />
          </SvgIcon>
        </IconButton>
      )}
    </Box>
  );
};

Search.propTypes = {
  onChange: func.isRequired,
  isFetching: bool,
};

export default memo(Search);
